module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"plan":"Your plan","changePlan":"Change plan"}}')
  delete Component.options._Ctor
}
